import { StatusEnum } from './status';

export const ConfirmationModalType = StatusEnum;

export const DISCARD_CHANGES_MESSAGE = 'Discard unsaved changes?';

export const UNSAVED_LEAVE_PROMPT_MESSAGE =
  'You have unsaved changes. Leave this page and lose them?';
